export default __webpack_public_path__ + "static/media/ketosis_energized@2x.78ab8ac2.jpg";